export default __webpack_public_path__ + "static/media/PregnancyImg.fa17edab.png";